/* Publish by EComposer at 2024-07-08 13:12:06*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-qvaszycgd3d"]=  window.__ectimmers["ecom-qvaszycgd3d"] || {};
if(!this.$el)return;const e=this.$el,i=e.querySelector(".ecom-text_view-more-btn"),t=e.querySelector(".ecom-text_view-less-btn"),n=e.querySelector(".text-content.ecom-html");!n||(i&&i.addEventListener("click",()=>{n.classList.remove("ecom-text--is-mark"),n.style.maxHeight="",i.style.display="none",t.style.display=""}),t&&t.addEventListener("click",()=>{n.classList.add("ecom-text--is-mark"),n.style.maxHeight="var(--ecom-text-height)",t.style.display="none",i.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-qvaszycgd3d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qvaszycgd3d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cwkptao2m7d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cwkptao2m7d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xgvdxfpzor').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xgvdxfpzor', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ysy4io3bnfq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ysy4io3bnfq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0nxi9qc4c90p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0nxi9qc4c90p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3nofx1dcip3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3nofx1dcip3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o4dhro4jj1o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o4dhro4jj1o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-roitxp6zee').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-roitxp6zee', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k0lgtc1f6vn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k0lgtc1f6vn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-h9v3zncr634').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-h9v3zncr634', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-26a7vddluqj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-26a7vddluqj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q3n69hg7fa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q3n69hg7fa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dvzedxbrcm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dvzedxbrcm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bwk21fi83w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bwk21fi83w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yuwmhebeztj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yuwmhebeztj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cfypc8tfff8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cfypc8tfff8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b7ljiiniiqn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b7ljiiniiqn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zcanxpjryi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zcanxpjryi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sx94m33t52k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sx94m33t52k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dh0my4v3pa5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dh0my4v3pa5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nyxj7r03nhc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nyxj7r03nhc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-872pt4f87c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-872pt4f87c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ifpsw8l7vwr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ifpsw8l7vwr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c9xws9k25ab').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c9xws9k25ab', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qew0ewlmes').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qew0ewlmes', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3xy3wokjwdk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3xy3wokjwdk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jfq2ucf7n6s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jfq2ucf7n6s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8qhevd0hagw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8qhevd0hagw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-is5zl7xo86m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-is5zl7xo86m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oonwsujaqr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oonwsujaqr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f8upz1ipi8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f8upz1ipi8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mhnx5e7nht').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mhnx5e7nht', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ugsefvt4qkf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ugsefvt4qkf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1rd7if8cir2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1rd7if8cir2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w7s789allg9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w7s789allg9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b8rfzdf0nz8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b8rfzdf0nz8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ey452s9yqv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ey452s9yqv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vtn4tw50hn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vtn4tw50hn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0qdv2t9wzyud').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0qdv2t9wzyud', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e2dvvq5tyh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e2dvvq5tyh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ajv0xybg99b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ajv0xybg99b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-amh3r48cho').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-amh3r48cho', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-40iqcvwgm0u').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-40iqcvwgm0u', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-98l5ijput4i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-98l5ijput4i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-858oimweo2w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-858oimweo2w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sf9zknd03xd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sf9zknd03xd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hvs3ym4ejr4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hvs3ym4ejr4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cz9w7loeapa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cz9w7loeapa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kunb4wnsxmo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kunb4wnsxmo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hoer1lwnyx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hoer1lwnyx', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wklzne2x91').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wklzne2x91', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uklw60p7zv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uklw60p7zv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0xyl0498628k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0xyl0498628k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m4er6q6x48o').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m4er6q6x48o', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rggw4sqalel').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rggw4sqalel', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0k91ps1rkj1h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0k91ps1rkj1h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fmdikkvlorn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fmdikkvlorn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ul02z19hk3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ul02z19hk3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vx5tzyukdd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vx5tzyukdd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ptpf3535jlj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ptpf3535jlj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r08wr7hyrcn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r08wr7hyrcn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-okiycpl19t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-okiycpl19t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tkzg2dc5j4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tkzg2dc5j4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1fyx3uqhqsz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1fyx3uqhqsz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o5c7fhfve5c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o5c7fhfve5c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-aderlt0cvr4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-aderlt0cvr4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dsci9vnkkp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dsci9vnkkp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ri2cbogpos8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ri2cbogpos8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-irljyy152fs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-irljyy152fs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eaib5dv4ma8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eaib5dv4ma8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gjyt9gwcp7w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gjyt9gwcp7w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-918cnvucfeg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-918cnvucfeg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-wqrrw4hazk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-wqrrw4hazk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r4c1flfbbl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r4c1flfbbl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vq3q7aoymi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vq3q7aoymi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-twg6e2hfe4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-twg6e2hfe4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bsdyzd42pcg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bsdyzd42pcg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mz10pvvvbzn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mz10pvvvbzn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nrjqipfwdc9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nrjqipfwdc9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xp09ute4mws').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xp09ute4mws', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-c5kb0gzxrzl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-c5kb0gzxrzl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uz0ygm6y0v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uz0ygm6y0v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j4pi28wmqcq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j4pi28wmqcq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5e3ptcqqerd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5e3ptcqqerd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ed3jrygvjhr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ed3jrygvjhr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mvk0puczjb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mvk0puczjb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sbtf3ua75g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sbtf3ua75g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u952j9zz7nf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u952j9zz7nf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dvzyanyszsn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dvzyanyszsn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n1v1908myzh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n1v1908myzh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ilqsb8i6jf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ilqsb8i6jf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a4od4pbjbuj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a4od4pbjbuj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zqou8aytnl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zqou8aytnl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7yunu6chska').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7yunu6chska', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-dtx66ho7qsr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dtx66ho7qsr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-07w7t7ykv6hs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-07w7t7ykv6hs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9c271zqk3i5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9c271zqk3i5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m2eqbznzb1b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m2eqbznzb1b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ctpx0hmkn9w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ctpx0hmkn9w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b2mrm5daz4e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b2mrm5daz4e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vsu9bw2i4sm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vsu9bw2i4sm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qbb64mtebo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qbb64mtebo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-87za6ipc56n').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-87za6ipc56n', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4ppweod1a2c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4ppweod1a2c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9t582qa6kc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9t582qa6kc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d70pkrgo5xi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d70pkrgo5xi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5ngpp897bsc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5ngpp897bsc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fn8hpvggzdh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fn8hpvggzdh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g5yuqfl53ri').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g5yuqfl53ri', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j07k6n12egi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j07k6n12egi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3mhcba0fsas').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3mhcba0fsas', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9nru3bzykdc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9nru3bzykdc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-s8db46webpm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-s8db46webpm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-69jq7rjihn4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-69jq7rjihn4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bupdiifhc6a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bupdiifhc6a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2t1dvl8rmc7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2t1dvl8rmc7', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t27ndvqbyu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t27ndvqbyu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m5138435xbg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m5138435xbg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7etlvm52m3k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7etlvm52m3k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ibfm5aksmrs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ibfm5aksmrs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xgcxwpti0fb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xgcxwpti0fb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kxo94hbcmij').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kxo94hbcmij', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6y5lbd3lftd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6y5lbd3lftd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-byfobr4pf65').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-byfobr4pf65', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9ew93icq1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9ew93icq1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-22nzymvm4nc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-22nzymvm4nc', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bp2bnff97lr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bp2bnff97lr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-23i1rba6gmi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-23i1rba6gmi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8sjd64djvwt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8sjd64djvwt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mybiqpy1esn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mybiqpy1esn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kh7z998gexm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kh7z998gexm', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9kxraq17wk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9kxraq17wk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8a8uvorrfz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8a8uvorrfz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pynsqozxfh8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pynsqozxfh8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bkqqbrthbbf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bkqqbrthbbf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xiilwvr7548').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xiilwvr7548', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2bf7vxpup9i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2bf7vxpup9i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2ihv2gdk2x').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2ihv2gdk2x', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ndnchzaoej').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ndnchzaoej', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-23d3x5w3r8g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-23d3x5w3r8g', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5mj9ya7pu9s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5mj9ya7pu9s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kllyj6erqo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kllyj6erqo', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-d6pbkz90zsa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-d6pbkz90zsa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oshcnzg0l5f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oshcnzg0l5f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g1xpugxmhzq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g1xpugxmhzq', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4zcetnf0gei').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4zcetnf0gei', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i0llsgiq82c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i0llsgiq82c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g2rafvuyjri').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g2rafvuyjri', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pvy4tc73h1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pvy4tc73h1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cfrv8kwih0w').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cfrv8kwih0w', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4ibnav37k7c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4ibnav37k7c', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nhqiqdbsxrk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nhqiqdbsxrk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g25lp4nsh5v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g25lp4nsh5v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-14i2pj5tx0s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-14i2pj5tx0s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rld0dz6bdl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rld0dz6bdl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-njv78g2c0en').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-njv78g2c0en', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xiqsghlr7e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xiqsghlr7e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cq5fybfeayp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cq5fybfeayp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w8shmif9gz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w8shmif9gz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-irk4ux71nsk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-irk4ux71nsk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lidp9h4b79').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lidp9h4b79', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xcp3vqibvce').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xcp3vqibvce', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5cv1s1r55b8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5cv1s1r55b8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cnd2v2cjzig').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cnd2v2cjzig', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i72t57zn1b').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i72t57zn1b', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-uyudbg3dmr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-uyudbg3dmr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q4g2ejnw95f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q4g2ejnw95f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3lxlmh8uwgt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3lxlmh8uwgt', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-45tbtbtx0d2').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-45tbtbtx0d2', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-axnm647rzbw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-axnm647rzbw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x4rrnk6d61').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x4rrnk6d61', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xvai1y26wz8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xvai1y26wz8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vh9jxljtecp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vh9jxljtecp', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xseqfn0cipe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xseqfn0cipe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-klxg082zl9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-klxg082zl9', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a0r9vmhrw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a0r9vmhrw', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t62vjvxp3mh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t62vjvxp3mh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vjj108tl0on').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vjj108tl0on', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-etvaw9l8qvv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-etvaw9l8qvv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-njxka6n0phg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-njxka6n0phg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-avy6vpm9mh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-avy6vpm9mh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1ysvju7y56s').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1ysvju7y56s', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-09tp0g00tmwa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-09tp0g00tmwa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ulqr6k2d4ul').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ulqr6k2d4ul', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-33tky0dr2m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-33tky0dr2m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-48hf1xnv5rb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-48hf1xnv5rb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vx22d5p1jrn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vx22d5p1jrn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fuyztf2ev78').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fuyztf2ev78', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qmqnnl274yd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qmqnnl274yd', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-oisrxrai8y').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-oisrxrai8y', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a48pmuoej6e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a48pmuoej6e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ycnu35alfh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ycnu35alfh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-py31w1chqsn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-py31w1chqsn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o4k5h6gyk4m').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o4k5h6gyk4m', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x3g66361wlk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x3g66361wlk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mbokwdmwmip').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mbokwdmwmip', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ndoy7qbo1fe').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ndoy7qbo1fe', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vg69ieuumrh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vg69ieuumrh', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-gu5j6srsrfl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-gu5j6srsrfl', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m5zzio98y2t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m5zzio98y2t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xquse5bqui').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xquse5bqui', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-bn2ddcd8khv').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-bn2ddcd8khv', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9sfsyzyfuas').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9sfsyzyfuas', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8cbpff0c0ol').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8cbpff0c0ol', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ydtx59z1ucr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ydtx59z1ucr', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i100d9cab1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i100d9cab1', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b2169eac3cn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b2169eac3cn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6mpym3jqpy4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6mpym3jqpy4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u7466torhff').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u7466torhff', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m8lxr5up99i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m8lxr5up99i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vh1150f5h6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vh1150f5h6', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0z7mwq0a3fu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0z7mwq0a3fu', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kcnvt8ue0e').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kcnvt8ue0e', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6d8bpuemjth').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6d8bpuemjth', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9t5j0vje0qa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9t5j0vje0qa', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0a77e5f35bqj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0a77e5f35bqj', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-0jrhdmgdysm"]=  window.__ectimmers["ecom-0jrhdmgdysm"] || {};
let e=this.$el;if(!e)return;let i=e.querySelectorAll(":scope > .tabs__wrapper > .tabs__navs > .tabs__navs--items > .tabs__nav"),t=e.querySelectorAll(":scope > .tabs__wrapper > .core__group--items > .tab__item"),n=this.settings.action;i.forEach((a,r)=>{n==="click"||window.screen.width<1025?a.onclick=function(){this.classList&&this.classList.contains("ecom-item-active")?(i.forEach(c=>c.classList.remove("ecom-item-active")),t.forEach(c=>c.classList.remove("ecom-item-active"))):(i.forEach(c=>c.classList.remove("ecom-item-active")),t.forEach(c=>c.classList.remove("ecom-item-active")),a.classList.add("ecom-item-active"),t[r].classList.add("ecom-item-active")),o()}:a.onmouseover=function(){this.classList&&this.classList.contains("ecom-item-active")?(i.forEach(c=>c.classList.remove("ecom-item-active")),t.forEach(c=>c.classList.remove("ecom-item-active"))):(i.forEach(c=>c.classList.remove("ecom-item-active")),t.forEach(c=>c.classList.remove("ecom-item-active")),a.classList.add("ecom-item-active"),t[r].classList.add("ecom-item-active")),o()}});function s(){let a=window.location.hash;if(a){let r=e.querySelector(`[data-target="${a}"]`);if(r){r.click();let l=r.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;window.scrollTo(0,l)}}}setTimeout(()=>{s()},300);function o(){window.dispatchEvent(new window.Event("resize")),setTimeout(()=>{window.dispatchEvent(new window.Event("resize"))},500)}window.addEventListener("hashchange",s,!1)

                    });
                    
                        document.querySelectorAll('.ecom-0jrhdmgdysm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0jrhdmgdysm', settings: {"action":"click"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ubxzilibybm"]=  window.__ectimmers["ecom-ubxzilibybm"] || {};
if(!this.settings||!this.$el)return;var e=this.$el.querySelector(".ecom-video_overlay-icon");e&&e.addEventListener("click",()=>{if(this.settings.source=="hosted"||this.settings.source=="uploaded"){let n=this.$el.querySelector(".ecom_video");n.autoplay=!0,n.load(),this.$el.querySelector(".ecom-video_overlay-icon").classList.remove("ecom-overlay"),this.$el.querySelector(".ecom-video-icon-play").style.display="none"}else{let n=this.$el.querySelector(".ecom_iframe"),s=n.getAttribute("src");s.includes("autoplay=0")?s=s.replace("autoplay=0","autoplay=1"):s=s+"&autoplay=1",n.setAttribute("src",s),this.$el.querySelector(".ecom-video_overlay-icon").classList.remove("ecom-overlay"),this.$el.querySelector(".ecom-video-icon-play").style.display="none"}}),this.$el.querySelectorAll("[data-ec-tracking-id]").forEach(function(n){n.dataset.ecTrackingId&&n.addEventListener("click",function(){window.Shopify.analytics&&Shopify.analytics.publish("ec_custom_events",{button_id:n.id,tracking_id:n.dataset.ecTrackingId})},{once:!0})});const i=this.$el.querySelector("[ecom-modal]");if(i&&this.settings.image_overlay&&this.settings.play_on_lightbox&&window.EComModal){var t=this.id;new window.EComModal(i,{cssClass:[t,"ecom-core","ecom-core-simulator"],onOpen:function(){var n=document.querySelector(".ecom-modal."+t);n&&n.querySelector(".ecom-modal-box__content").classList.add("ecom-element_video-iframe")}})}

                    });
                    
                        document.querySelectorAll('.ecom-ubxzilibybm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ubxzilibybm', settings: {"source":"uploaded"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-es3w1v8swj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-es3w1v8swj', settings: {"source":"uploaded"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rag93mls7').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rag93mls7', settings: {"source":"uploaded"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1vm0wv2ya81').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1vm0wv2ya81', settings: {"source":"hosted"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-2ajellss7pp"]=  window.__ectimmers["ecom-2ajellss7pp"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var e=this.$el.querySelector("[ecom-modal]");new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+this.id]})}let i=this.$el;if(!i)return;function t(s){const o=s.getBoundingClientRect();return o.top>=0&&o.left>=0&&o.bottom-s.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&o.right<=(window.innerWidth||document.documentElement.clientWidth)}function n(){let s=i.querySelector(".ecom-element.ecom-base-image"),o=i.closest(".core__row--columns");s&&(t(s)?(s.classList.add("image-highlight"),o.setAttribute("style","z-index: unset")):(s.classList.remove("image-highlight"),o.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){n()})

                    });
                    
                        document.querySelectorAll('.ecom-2ajellss7pp').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2ajellss7pp', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ga8bw1oh1tm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ga8bw1oh1tm', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2g407t3mp8i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2g407t3mp8i', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-syr6uy9hzxq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-syr6uy9hzxq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xpoc4wchlcm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xpoc4wchlcm', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6ijdy8g3hh3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6ijdy8g3hh3', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-deqsun9d247').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-deqsun9d247', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fkdaffidtyq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fkdaffidtyq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-cdyarrpdnx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-cdyarrpdnx', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hc42j3qrtib').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hc42j3qrtib', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-to0r90m0sxb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-to0r90m0sxb', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8x9c8r7y42l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8x9c8r7y42l', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kj5wyb2wcne').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kj5wyb2wcne', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b9qr89n7v3k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b9qr89n7v3k', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0nae8tm0iro').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0nae8tm0iro', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rcpajswvd9l').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rcpajswvd9l', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w6mxkgzcvo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w6mxkgzcvo', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-635d2p008d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-635d2p008d', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-upu570jxnnr').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-upu570jxnnr', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rnrd9nn7ces').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rnrd9nn7ces', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-9petcved3xn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-9petcved3xn', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kqoqryw1jn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kqoqryw1jn', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-x5yafwma9bl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-x5yafwma9bl', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-juyxuo8dgbo').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-juyxuo8dgbo', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ibnmgr72hzf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ibnmgr72hzf', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yvhg58eitgi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yvhg58eitgi', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jkhjgrenszs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jkhjgrenszs', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-pwva6n8y6sc').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-pwva6n8y6sc', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q3v48trx04h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q3v48trx04h', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-r12laufx3np').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-r12laufx3np', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ot7ht43rogf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ot7ht43rogf', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-346637h0uzf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-346637h0uzf', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4l5vvk8j3rq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4l5vvk8j3rq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-2qox177umdw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-2qox177umdw', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-20eswwbz8ka').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-20eswwbz8ka', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hszudrrztp5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hszudrrztp5', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j2ypossizfl').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j2ypossizfl', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-73ub3tgn7c').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-73ub3tgn7c', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1uad9zhh3d9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1uad9zhh3d9', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lbztgfncdlk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lbztgfncdlk', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kh1nzpyklho').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kh1nzpyklho', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ej0lgks6lsw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ej0lgks6lsw', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6fsuqvssczt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6fsuqvssczt', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sswm2lo9cy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sswm2lo9cy', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ict16raufta').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ict16raufta', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8f4ucor6mq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8f4ucor6mq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-yj3p9p5aug').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-yj3p9p5aug', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-nl3f1p8b2ye').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-nl3f1p8b2ye', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7mpy8xu8uuw').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7mpy8xu8uuw', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-70n1ut5wrsm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-70n1ut5wrsm', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z6sjbsdi4hj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z6sjbsdi4hj', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ybf7psv1kpd').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ybf7psv1kpd', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ppq3xbs8r1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ppq3xbs8r1', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vua3tnx8cg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vua3tnx8cg', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7pvxwatpqsy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7pvxwatpqsy', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ii3842oo2la').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ii3842oo2la', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ohxby3qeoxh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ohxby3qeoxh', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-6z2rvkm1fpn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-6z2rvkm1fpn', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fu1yxtih3i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fu1yxtih3i', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-643b8q2z0eb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-643b8q2z0eb', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jrl8bqhksxh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jrl8bqhksxh', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sbkbheql64a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sbkbheql64a', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q3w2lqrgwyh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q3w2lqrgwyh', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-u8yhb7xkizh').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-u8yhb7xkizh', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-98tgvnrwah8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-98tgvnrwah8', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hhhl6sj5quq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hhhl6sj5quq', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-xta41lh3dn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-xta41lh3dn', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-afus8puwoyj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-afus8puwoyj', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ullgd4tab4j').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ullgd4tab4j', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-3pb9dimpf3q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-3pb9dimpf3q', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zh3tq21cxjs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zh3tq21cxjs', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-g07hn28vkyu').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-g07hn28vkyu', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}